import React from "react";
import { useParams, Navigate } from "react-router-dom";
import UsersManagement from "views/admin/users-management";

const CenterUsersMgmt = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <UsersManagement centerId={centerId} />;
};

export default CenterUsersMgmt;
